export enum SelectPredefinedOptions {
    CHOOSE = 'choose',
    NOT_REPEAT ='not_repeat',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    ANNUALLY = 'annually',
    WEEKDAY = 'weekday',
    CUSTOM = 'custom',
    USER_DEFINED = 'user_defined',
}